<template lang="html">
  <BaseDialog
    v-model="localValue"
    min-width="500"
    persistent
    has-cancel
    :title="$t('general.remove')"
    :content="$t('general.are_you_sure')"
    @continue="handleDelete()"
  />
</template>

<script>
import localValue from '@/mixins/localValue';

export default {
  mixins: [localValue],
  props: {
    resourceId: {
      type: [Number, String],
      required: true,
    },
    deleteServiceAction: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async handleDelete() {
      try {
        var loading = await this.$store.dispatch('load');
        await this.deleteServiceAction(this.resourceId);
        this.$emit('delete', true);
        this.localValue = false;
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.dispatch('unload', loading);
      }
    },
  },
}
</script>

<style lang="css" scoped>
</style>